<svg xmlns="http://www.w3.org/2000/svg" width="89" height="89" viewBox="0 0 89 89">
    <g transform="translate(-4437 -3447)">
        <circle class="user-icon-circle" cx="44.5" cy="44.5" r="44.5" transform="translate(4437 3447)" fill="#757575" />
        <path class="user-icon-figure" d="M-12.639-14.12c7.666-4.843,23.334-4.843,31,0s0,19,0,19h-31S-20.305-9.277-12.639-14.12Z" transform="translate(4478.639 3508.12)" fill="#e5e5e5" />
        <circle class="user-icon-figure" cx="10.5" cy="10.5" r="10.5" transform="translate(4471 3468)" fill="#e5e5e5" />
    </g>
</svg>